module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_3_1-ec516b731970e075a871ed1ea3881b06.png";